import { ref, computed } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { useApi } from '@/composables/useApi';
import { useRoute } from 'vue-router';
import { useKioskStore } from '@/stores/useKioskStore';

export const useTranslationsStore = defineStore('translations', () => {
	const { request } = useApi();
	const { locale } = storeToRefs(useKioskStore());
	const route = useRoute();

	const data = ref(null);
	const kioskId = computed(() => route.params.kioskId);

	async function fetchTranslations() {
		if (!kioskId.value) return;

		const response = await request(`/api/${kioskId.value}/translation`);
		data.value = response;
	}

	const translations = computed(() => {
		if (!data.value) return {};
		return data.value[locale.value === 'cs' ? 'cz' : locale.value] || {};
	});

	return {
		translations,
		fetchTranslations,
	};
});
